export default __webpack_public_path__ + "static/wide-9379a04f322f69743b6f5829529af422.jpg";